import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CentrosProcesoService {
  
  constructor(private readonly http: HttpClient) { }

  crearCentrosProceso(data:any): Observable<any[]> {
    const headers = { 'Content-Type': 'application/json' };
    const body = JSON.stringify(data);
    return this.http.post<any>(`${environment.API_DOMAINS.OTIC_CR}/centrosProceso/crearCentrosProceso`,body, { headers });
  }

  actualizarEstadoCentroProceso(data:any): Observable<any[]> {
    const headers = { 'Content-Type': 'application/json' };
    const body = JSON.stringify(data);
    return this.http.post<any>(`${environment.API_DOMAINS.OTIC_CR}/centrosProceso/actualizarEstadoCentroProceso`,body, { headers });
  }

  actualizarAnalistaFinanzas(data:any): Observable<any[]> {
    const headers = { 'Content-Type': 'application/json' };
    const body = JSON.stringify(data);
    return this.http.post<any>(`${environment.API_DOMAINS.OTIC_CR}/centrosProceso/actualizarAnalistaFinanzas`,body, { headers });
  }

  actualizarSimulacionId(data:any): Observable<any[]> {
    const headers = { 'Content-Type': 'application/json' };
    const body = JSON.stringify(data);
    return this.http.post<any>(`${environment.API_DOMAINS.OTIC_CR}/centrosProceso/actualizarSimulacionId`,body, { headers });
  }

  actualizarProcesadoId(data:any): Observable<any[]> {
    const headers = { 'Content-Type': 'application/json' };
    const body = JSON.stringify(data);
    return this.http.post<any>(`${environment.API_DOMAINS.OTIC_CR}/centrosProceso/actualizarProcesadoId`,body, { headers });
  }

  actualizarDocumentoOk(data:any): Observable<any[]> {
    const headers = { 'Content-Type': 'application/json' };
    const body = JSON.stringify(data);
    return this.http.post<any>(`${environment.API_DOMAINS.OTIC_CR}/centrosProceso/actualizarDocumentoOk`,body, { headers });
  }

  actualizarDocumentoFallo(data:any): Observable<any[]> {
    const headers = { 'Content-Type': 'application/json' };
    const body = JSON.stringify(data);
    return this.http.post<any>(`${environment.API_DOMAINS.OTIC_CR}/centrosProceso/actualizarDocumentoFallo`,body, { headers });
  }

  actualizarSeleccionEspecial(data:any): Observable<any[]> {
    const headers = { 'Content-Type': 'application/json' };
    const body = JSON.stringify(data);
    return this.http.post<any>(`${environment.API_DOMAINS.OTIC_CR}/centrosProceso/actualizarSeleccionEspecial`,body, { headers });
  }

  actualizarDataArchivo(data:any): Observable<any[]> {
    const headers = { 'Content-Type': 'application/json' };
    const body = JSON.stringify(data);
    return this.http.post<any>(`${environment.API_DOMAINS.OTIC_CR}/centrosProceso/actualizarDataArchivo`,body, { headers });
  }

  actualizarDatosSimulacion(data:any): Observable<any[]> {
    const headers = { 'Content-Type': 'application/json' };
    const body = JSON.stringify(data);
    return this.http.post<any>(`${environment.API_DOMAINS.OTIC_CR}/centrosProceso/actualizarDatosSimulacion`,body, { headers });
  }

  anularProcesamientoCentro(data:any): Observable<any[]> {
    const headers = { 'Content-Type': 'application/json' };
    const body = JSON.stringify(data);
    return this.http.post<any>(`${environment.API_DOMAINS.OTIC_CR}/centrosProceso/anularProcesamientoCentro`,body, { headers });
  }

  listarCentrosProceso(procId: any): Observable<any[]> {   
    return this.http.get<any>(`${environment.API_DOMAINS.OTIC_CR}/centrosProceso/listarCentrosProceso/${procId}`);
  }

  listarCentrosProcesoEspecial(procId: any): Observable<any[]> {   
    return this.http.get<any>(`${environment.API_DOMAINS.OTIC_CR}/centrosProceso/listarCentrosProcesoEspecial/${procId}`);
  }

  simularProcesamiento(data:any): Observable<any[]> {
    const headers = { 'Content-Type': 'application/json' };
    const body = JSON.stringify(data);
    return this.http.post<any>(`${environment.API_DOMAINS.OTIC_CR}/simulacion/simularProcesamiento`,body, { headers });
  }
  
  procesarCentro(data:any): Observable<any[]> {
    const headers = { 'Content-Type': 'application/json' };
    const body = JSON.stringify(data);
    return this.http.post<any>(`${environment.API_DOMAINS.OTIC_CR}/procesamiento/procesar`,body, { headers });
  }
}
